import React, { useState, useEffect } from "react";
import {
  Modal,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Constants from "../../utils/constants";
import "./styles.scss";

const { LANGUAGES } = Constants;

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const LanguageModal = (props) => {
  const { open, handleClose, handleLangChange, lang, themeColour } = props;
  const [modalStyle] = useState(getModalStyle);
  const [value, setValue] = useState(lang);
  const classes = useStyles();

  const handleChange = (event) => {
    setValue(event.target.value);
    handleLangChange(event.target.value);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>{LANGUAGES.language[lang]}</h3>
          <span className="close-btn" onClick={handleClose}>
            x
          </span>
        </div>
        <FormControl component="fieldset">
          <RadioGroup value={value} onChange={handleChange}>
            <FormControlLabel
              value="zh"
              control={<Radio style={{ color: themeColour || "#3399FF" }} />}
              label="繁體中文"
            />
            <FormControlLabel
              value="en"
              control={<Radio style={{ color: themeColour || "#3399FF" }} />}
              label="English"
            />
            <FormControlLabel
              value="cn"
              control={<Radio style={{ color: themeColour || "#3399FF" }} />}
              label="简体中文"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </Modal>
  );
};

export default LanguageModal;
